import { Outlet } from 'react-router-dom';

import List from './List';
import Meta from "../../components/Meta";
import Header from "../../components/Header";

import styles from '../../../styles/Admin.module.scss';

function Template() {
    return (
        <>
            <Meta title="Transactions" />
            <Header heading="Transactions" />
            <main>
                <Outlet />
            </main>
        </>
    );
}

export default { Template, List };
